export const LOGO =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_5f9461bb-28a7-4bac-8192-aecb42807f6c/artifacts/o2i65m5i_ChatGPT%20Image%20Jul%2021%2C%202026%2C%2005_14_37%20PM.png";

// Full-bleed image displayed immediately below the hero — loft with steel windows
export const FULL_PAGE_IMAGE = {
  src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/mmjyvrt7_W40.jpg",
  label: "Steel Window · W40",
  caption: "Milano Loft · double-height steel fenestration",
};

// Cards used in the kinetic hero (center + 2 side)
export const IMAGES = [
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/on2yhj9u_W50TB.jpg",
    label: "Arched Steel Pivot",
    caption: "Arched steel pivot with thermal break",
  },
  {
    // Replaces the previous video on the LEFT card — brass-framed steel window
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/4ojvhgoi_Ottostumm%20Mogs%20FerroFinestra%20%20B75%20TB%202.webp",
    label: "Brass-Framed Window",
    caption: "Brass-framed steel window",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/lam852jj_Ottostumm%20Mogs%20FerroFinestra%20W75%20%281%29%20%281%29.jpg",
    label: "Pivot Glass Door",
    caption: "Pivot glass door · thermal break",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_eurosteel-hero/artifacts/i4f8ig1m_DSCF5696.webp",
    label: "Architectural Facade",
    caption: "Architectural facades in steel",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/q0x6qw02_DSCF5583.webp",
    label: "Reeded Glass Doors",
    caption: "Full-height steel doors · fluted glass",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/n21lw9j2_DSCF4278.webp",
    label: "Courtyard Glazing",
    caption: "Living space · courtyard glazing",
  },
];

// Full products / gallery grid — every architectural image on the site
export const PRODUCTS = [
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/on2yhj9u_W50TB.jpg",
    title: "W50 TB",
    subtitle: "Steel Pivot · Arched",
    tag: "Steel Doors",
    span: "tall",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/lam852jj_Ottostumm%20Mogs%20FerroFinestra%20W75%20%281%29%20%281%29.jpg",
    title: "W75",
    subtitle: "Pivot Glazing System",
    tag: "Steel Doors",
    span: "wide",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/ce99adya_IMG_8495.webp",
    title: "W20",
    subtitle: "Interior Fenestration",
    tag: "Steel Windows",
    span: "tall",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/mmjyvrt7_W40.jpg",
    title: "W40",
    subtitle: "Brass-Framed Steel Window",
    tag: "Steel Windows",
    span: "tall",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_5f9461bb-28a7-4bac-8192-aecb42807f6c/artifacts/itfrbrs8_Ottostumm%20Mogs%20FerroFinestra%20%20W50.jpg",
    title: "W50",
    subtitle: "Thermal-broken Steel Glazing",
    tag: "Steel Windows",
    span: "wide",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_5f9461bb-28a7-4bac-8192-aecb42807f6c/artifacts/y64khv2b_Ottostumm%20Mogs%20-%20FerroFinestra%20W40.jpg",
    title: "W40 · Loggia",
    subtitle: "Slim-profile Veranda Systems",
    tag: "Aluminium Systems",
    span: "wide",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_5f9461bb-28a7-4bac-8192-aecb42807f6c/artifacts/t3a2w0i4_Ottostumm%20Mogs%20-%20FerroFinestra%20W40%20b.jpg",
    title: "W40 B",
    subtitle: "Bespoke Pivot Doors",
    tag: "Steel Doors",
    span: "tall",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_5f9461bb-28a7-4bac-8192-aecb42807f6c/artifacts/comj7zx5_Ottostumm%20Mogs%20-%20FerroFinestra%20W20%20b.jpg",
    title: "W20 B",
    subtitle: "Architectural Facades",
    tag: "Steel Windows",
    span: "wide",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/4ojvhgoi_Ottostumm%20Mogs%20FerroFinestra%20%20B75%20TB%202.webp",
    title: "B75 TB",
    subtitle: "Thermal-Break Steel Doors",
    tag: "Steel Doors",
    span: "tall",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_eurosteel-hero/artifacts/i4f8ig1m_DSCF5696.webp",
    title: "Eurosteel Studio",
    subtitle: "Milano Showroom",
    tag: "Projects",
    span: "wide",
  },
];

export const HANDLES = [
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/vlljdsbx_Screenshot%202026-07-15%20at%2012.27.21%E2%80%AFPM.png",
    name: "Solaro",
    finish: "Polished Brass · Reeded",
    code: "H-01",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/05n4xnfw_Screenshot%202026-07-15%20at%2012.27.25%E2%80%AFPM.png",
    name: "Argyle",
    finish: "Graphite Bronze · Chevron",
    code: "H-02",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/8gx0cmgh_Screenshot%202026-07-15%20at%2012.27.30%E2%80%AFPM.png",
    name: "Onda",
    finish: "Antique Bronze · Wave",
    code: "H-03",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/s8umi6d1_Screenshot%202026-07-15%20at%2012.27.34%E2%80%AFPM.png",
    name: "Corno",
    finish: "Matte Black Nickel",
    code: "H-04",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/15khdggg_Screenshot%202026-07-15%20at%2012.27.38%E2%80%AFPM.png",
    name: "Rigato",
    finish: "Satin Brass · Fluted",
    code: "H-05",
  },
];

export const PARTNERS = [
  {
    name: "Ottostumm | Mogs",
    logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/yipki2cv_Logo%20ottostumm-mogs_NEGATIVO.webp",
  },
];

// Dark version of the Ottostumm | Mogs wordmark for use on white backgrounds
export const OTTOSTUMM_LOGO_DARK =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_157d7ec9-9755-4d04-9c3c-44ca1fe42198/artifacts/xcxqoys5_Logo%20ottostumm-mogs_NEGATIVO.webp";

// Instagram feed placeholder posts — displayed in the @eurosteelnz carousel.
// Uses existing project photography so the carousel isn't empty until a
// LightWidget/SnapWidget embed is wired to the real @eurosteelnz account.
export const INSTAGRAM_POSTS = [
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/yj42hevn_Ottostumm%20Mogs%20FerroFinestra%20%20W50.jpg",
    caption: "Hillside pavilion complete · Umbria",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/77v6vg5z_DSCF1756.webp",
    caption: "Steel-framed dining room · install day",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/q0x6qw02_DSCF5583.webp",
    caption: "Full-height steel doors · reeded glass",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/1obfqlt4_Ottostumm%20Mogs%20-%20FerroFinestra%20W20%20b.jpg",
    caption: "Studio courtyard · thermal glazing",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/n21lw9j2_DSCF4278.webp",
    caption: "Living space · courtyard slider",
  },
  {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/s5295zz0_Ottostumm%20Mogs%20FerroFinestra%20%20B75%20TB%202.webp",
    caption: "Brass-framed steel window · Venetian brick",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/lam852jj_Ottostumm%20Mogs%20FerroFinestra%20W75%20%281%29%20%281%29.jpg",
    caption: "W75 pivot glass · client walk-through",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/on2yhj9u_W50TB.jpg",
    caption: "W50 TB pivot · workshop assembly",
  },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_eurosteel-hero/artifacts/i4f8ig1m_DSCF5696.webp",
    caption: "Architectural facade · fabricated in Auckland",
  },
];

// Full-bleed selected project image — displayed with fixed background-attachment
// so it stays pinned in the viewport while sections above and below scroll over it.
export const PROJECT_IMAGE = {
  src: "https://customer-assets-cm19k8pv.emergentagent.net/job_79d410ce-bad2-4f45-b915-a6981676b1a1/artifacts/27dy4414_Screenshot%202026-09-15%20at%207.17.14%E2%80%AFPM.png",
  title: "Interior Steel Screen · Auckland",
};

// Secondary selected project — full-house exterior, shown as a second pinned
// moment further down the homepage.
export const PROJECT_IMAGE_2 = {
  src: "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/yj42hevn_Ottostumm%20Mogs%20FerroFinestra%20%20W50.jpg",
  title: "Hillside Pavilion · Umbria",
};

// Featured Product Categories — 4 clickable cards under the Profiles section
export const PRODUCT_CATEGORIES = [
  {
    slug: "steel-doors",
    href: "/products/steel-doors",
    tag: "Steel Doors",
    title: "Steel Doors",
    objectPosition: "22% center",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/77v6vg5z_DSCF1756.webp",
  },
  {
    slug: "steel-windows",
    href: "/products/steel-windows",
    tag: "Steel Windows",
    title: "Steel Windows",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_fe0c775c-382e-4bf1-ab8e-bb795dea130b/artifacts/s5295zz0_Ottostumm%20Mogs%20FerroFinestra%20%20B75%20TB%202.webp",
  },
  {
    slug: "luxury-entrances",
    href: "/products/luxury-entrances",
    tag: "Luxury Entrances",
    title: "Luxury Entrances",
    image:
      "https://images.squarespace-cdn.com/content/v1/66779fe409a6942ed144de55/88452bd4-63a9-4480-b33e-24cb28edd0d1/IMG_1807.JPG?format=1500w",
  },
];

// System profile cutaways — shown in the Profiles section on white background
export const PROFILES = [
  {
    code: "W20",
    name: "W20 Steel",
    tagline: "Single glazed · Internal",
    description:
      "The slimmest FerroFinestra profile. Single-glazed steel with a minimal sight-line, designed for internal partitions, crittall-style screens and heritage restoration.",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_157d7ec9-9755-4d04-9c3c-44ca1fe42198/artifacts/08822cqo_W20%20Steel%20rev01.webp",
    specSheet: "/specs/FF-W20.pdf",
  },
  {
    code: "W40",
    name: "W40 Steel",
    tagline: "Double glazed · External",
    description:
      "A 40mm cold-formed steel profile suitable for double glazing and external applications. The versatile choice for windows, doors and façades where thermal break is not required.",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_157d7ec9-9755-4d04-9c3c-44ca1fe42198/artifacts/6mb3ypru_W40%20Steel.webp",
    specSheet: "/specs/FF-W40.pdf",
  },
  {
    code: "W50TB",
    name: "W50 TB Steel",
    tagline: "Thermal break · External",
    description:
      "Thermally-broken steel with a polyamide barrier. A 50mm profile that combines slim FerroFinestra sight-lines with contemporary energy performance for external openings.",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_157d7ec9-9755-4d04-9c3c-44ca1fe42198/artifacts/22zlgo1i_W50TB%20Steel.webp",
    specSheet: null,
  },
  {
    code: "W75TB",
    name: "W75 TB Inox",
    tagline: "Stainless · Thermal break",
    description:
      "The flagship 75mm thermally-broken stainless-steel profile. Engineered for large-format doors, structural façades and marine-grade durability.",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_157d7ec9-9755-4d04-9c3c-44ca1fe42198/artifacts/lip0jjbm_W75TB%20Inox%202018.webp",
    specSheet: null,
  },
  {
    code: "ALES65",
    name: "ALES65 Aluminium",
    tagline: "Aluminium Steel Look · Thermal break",
    description:
      "A thermally-broken aluminium profile engineered with a true steel-look sight-line. The everyday choice for full-house glazing where you want the razor-thin aesthetic of steel with the price, weight and thermal performance of aluminium.",
    image: "/profiles/ALES65.webp",
    specSheet: null,
  },
];

export const NAV_ITEMS = [
  { label: "Home", href: "/" },
  {
    label: "Products",
    href: "/products",
    children: [
      { label: "Steel Windows", href: "/products/steel-windows" },
      { label: "Steel Doors", href: "/products/steel-doors" },
      { label: "Luxury Entrances", href: "/products/luxury-entrances" },
      { label: "Hardware", href: "/products/hardware" },
      { label: "Designs", href: "/products/designs" },
    ],
  },
  { label: "Door Configurator", href: "/door-configurator" },
  { label: "Projects", href: "/projects" },
  {
    label: "Technical",
    href: "/technical",
    children: [
      { label: "Glazing Type", href: "/technical#glazing-type" },
      { label: "Mounting Types", href: "/technical#mounting-types" },
      { label: "Profile Specifications", href: "/technical#profile-specifications" },
      { label: "Finishes", href: "/finishes" },
      { label: "Hardware Options", href: "/technical#hardware-options" },
      { label: "Resources", href: "/technical#resources" },
    ],
  },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];
